var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVolumeEnable = function SvgIconVolumeEnable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M5.4 9.537a1.4 1.4 0 0 0-1.4 1.4v7a1.4 1.4 0 0 0 1.4 1.4h3.5l7.283 5.46a.7.7 0 0 0 1.12-.56v-19.6a.7.7 0 0 0-1.12-.56L8.9 9.537zM23.267 22.205a1.05 1.05 0 0 1-1.433-1.535c1.529-1.428 2.466-3.722 2.466-6.233s-.937-4.805-2.466-6.232a1.05 1.05 0 1 1 1.433-1.536c1.967 1.837 3.133 4.69 3.133 7.768s-1.166 5.931-3.133 7.768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M19.05 19.42a1.05 1.05 0 0 0 1.483-.084c1.056-1.182 1.667-2.976 1.667-4.899 0-1.922-.611-3.717-1.667-4.9a1.05 1.05 0 1 0-1.566 1.4c.692.775 1.133 2.07 1.133 3.5s-.44 2.725-1.133 3.5a1.05 1.05 0 0 0 .084 1.483"
  })));
};
export default SvgIconVolumeEnable;